var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.21262 0 0 2.21262 -39.453867 -1.770085)",
    fill: "#ee4c2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8 9.3l-2.1 2.1c3.5 3.5 3.5 9.2 0 12.7s-9.2 3.5-12.7 0-3.5-9.2 0-12.7l5.6-5.6.7-.8V.8l-8.5 8.5a11.89 11.89 0 0 0 0 16.9 11.89 11.89 0 0 0 16.9 0c4.8-4.7 4.8-12.3.1-16.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.6,
    cy: 7.1,
    cx: 36.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorchIcon);
export default __webpack_public_path__ + "static/media/pytorch-icon.8653d1d6d7ba93c4c4ed583bbd51fb99.svg";
export { ForwardRef as ReactComponent };